import { render, staticRenderFns } from "./CommonChip.vue?vue&type=template&id=598e8d79&lang=pug&"
import script from "./CommonChip.vue?vue&type=script&lang=ts&"
export * from "./CommonChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports